import { useTranslation } from "react-i18next";
import {
  ContractRole,
  ContractTaskRole,
  OrganizationRoleType,
  SourcingEventRole,
} from "../../../autogen/bff-api";
import { asGrantRole } from "../../organizations/current/manage-users/roleVocabulary";
import { useGrantRoleName } from "../../organizations/current/manage-users/useGrantRoleName";

export const useReceiverRoleNames = () => {
  const { t } = useTranslation();
  const grantRoleName = useGrantRoleName();

  const organizationRole = (role: OrganizationRoleType): string => {
    const grantRole = asGrantRole(role);
    return grantRole ? grantRoleName(grantRole) : role;
  };

  const contractRole = (role: ContractRole): string => {
    switch (role) {
      case ContractRole.InternalOwner:
        return t("Internal contract owner");
      case ContractRole.CounterParty:
        return t("Counterparty contact person");
      case ContractRole.InvitedParty:
        return t("Parties the contract is shared with");
    }
  };

  const sourcingEventRole = (role: SourcingEventRole): string => {
    switch (role) {
      case SourcingEventRole.Publisher:
        return t("The person who published the procurement");
      case SourcingEventRole.InvitedSupplier:
        return t("Invited suppliers");
    }
  };

  const contractTaskRole = (role: ContractTaskRole): string => {
    switch (role) {
      case ContractTaskRole.Responsible:
        return t("Responsible");
    }
  };

  return {
    organizationRole,
    contractRole,
    sourcingEventRole,
    contractTaskRole,
  };
};
